"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCssMedia = exports.cssMedia = exports.CSS_MEDIA_MIN_WIDTH = exports.CSS_MEDIA_MAX_WIDTH = void 0;
var _reactUse = require("react-use");
var CSS_MEDIA_MIN_WIDTH = {
  XXS: 0,
  XS: 361,
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200,
  XXL: 1600,
  INF: 32000
};
exports.CSS_MEDIA_MIN_WIDTH = CSS_MEDIA_MIN_WIDTH;
var CSS_MEDIA_MAX_WIDTH = {
  XXS: 0,
  XS: 360,
  SM: 575,
  MD: 767,
  LG: 991,
  XL: 1199,
  XXL: 1599,
  INF: 31999
};

/**
 * The hook allows to check in js state of css media queries which we use in monument-media.less
 * Feel free to add new media queries below.
 */
exports.CSS_MEDIA_MAX_WIDTH = CSS_MEDIA_MAX_WIDTH;
var useCssMedia = function useCssMedia() {
  var sm = (0, _reactUse.useMedia)("(min-width: ".concat(CSS_MEDIA_MIN_WIDTH.SM, "px)"));
  var smMax = (0, _reactUse.useMedia)("(max-width: ".concat(CSS_MEDIA_MAX_WIDTH.SM, "px)"));
  var md = (0, _reactUse.useMedia)("(min-width: ".concat(CSS_MEDIA_MIN_WIDTH.MD, "px)"));
  var mdMax = (0, _reactUse.useMedia)("(max-width: ".concat(CSS_MEDIA_MAX_WIDTH.MD, "px)"));
  var lg = (0, _reactUse.useMedia)("(min-width: ".concat(CSS_MEDIA_MIN_WIDTH.LG, "px)"));
  var lgMax = (0, _reactUse.useMedia)("(max-width: ".concat(CSS_MEDIA_MAX_WIDTH.LG, "px)"));
  var xl = (0, _reactUse.useMedia)("(min-width: ".concat(CSS_MEDIA_MIN_WIDTH.XL, "px)"));
  return {
    sm: sm,
    smMax: smMax,
    md: md,
    mdMax: mdMax,
    lg: lg,
    lgMax: lgMax,
    xl: xl,
    isAppointmentCubbyDesktop: md
  };
};
exports.useCssMedia = useCssMedia;
var cssMedia = {
  lg: function lg() {
    return window.innerWidth > CSS_MEDIA_MIN_WIDTH.LG;
  },
  mdMax: function mdMax() {
    return window.innerWidth < CSS_MEDIA_MAX_WIDTH.MD;
  }
};
exports.cssMedia = cssMedia;